// O Firebase só carrega com o painel (lib/auth registra o getter ao ser
// importado). Landing pública chama a API sem token e sem baixar o Firebase.
let getToken: (() => Promise<string | null>) | null = null;

export function setAuthTokenGetter(fn: () => Promise<string | null>) {
  getToken = fn;
}

/** Build the Authorization header for API requests when the user is signed in. */
export async function getAuthHeader(): Promise<Record<string, string>> {
  const token = getToken ? await getToken() : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}
